import {
  pathSettingsAppsPopularWords,
  pathSettingsBannedWords,
} from 'lib/paths'
import { Word } from 'lib/_types'
import { axiosShortQuery } from 'store/libs/baseQuery'
import { yayApi } from '../baseApi'

const settingsApi = yayApi
  .enhanceEndpoints({
    addTagTypes: ['PopuplarKeywords', 'BannedWords'],
  })
  .injectEndpoints({
    endpoints: (build) => ({
      getPopularKeywords: build.query({
        providesTags: ['PopuplarKeywords'],
        queryFn: axiosShortQuery(
          {
            url: pathSettingsAppsPopularWords,
            method: 'GET',
          },
          'settingsYay',
          (res: { popular_words: Array<Word> }) => res?.popular_words
        ),
      }),

      getBannedWords: build.query({
        providesTags: ['BannedWords'],
        queryFn: axiosShortQuery(
          {
            url: pathSettingsBannedWords,
            method: 'GET',
          },
          'settingsYay',
          (res: { ban_words: Array<Word> }) => res?.ban_words
        ),
      }),
    }),
    overrideExisting: false,
  })

export const { useGetPopularKeywordsQuery, useGetBannedWordsQuery } =
  settingsApi
